import React, { useContext } from 'react'
import {useState } from 'react'
import MyLocation from './MyLocation'
import { AppContext } from '../context/AppContext'
import {ReactComponent as BusIcon} from '../images/icon_bus.svg'
import {ReactComponent as TaxiIcon} from '../images/icon_taxi.svg'
import {ReactComponent as EvtolIcon} from '../images/icon_evtol.svg'



const CommuteIcon = ({options}) => {
    if (options == 'commute-bus') {
          return <BusIcon />
    } else if (options == 'commute-taxi') {
     return <TaxiIcon />
     } else if (options == 'commute-evtol') {
         return <EvtolIcon />
     } else {
         return ""
     }
 }


const TripInfoFinal = () => {

    
    const {tripDetails, infoShow, setInfoShow, closestAirports, commuteOptions} = useContext(AppContext)

    const toggleInfoShow = () => {
        if (infoShow) {
            setInfoShow(false)
        } else {
            setInfoShow(true)
        }
    }

    return (
        <div id="trip-info-final" className={`trip-info` + (infoShow ? " show" : " hide")}>
            <button onClick={toggleInfoShow} className="button icon-button toggle-info">&#9662;</button>
            <div className="trip-info-wrap">
            <div className="destinations info-box">
                    <span className="destination-from"><h3>{tripDetails.location}</h3></span>
                    <span className="dash">–</span> 
                    <span className="destination-to"><h3>{tripDetails.destination}</h3></span>
                </div>
                <div className="airports info-box">
                    <span className="airports-from"><h4>{closestAirports.from && `${closestAirports.from[0].name} (${closestAirports.from[0].abbreviation})`   }<CommuteIcon className="commute-from-icon" options={commuteOptions.from} /></h4></span>
                    <span className="dash">–</span> 
                    <span className="airports-to"><h4>{closestAirports.to && `${closestAirports.to[0].name} (${closestAirports.to[0].abbreviation})`}<CommuteIcon className="commute-from-icon" options={commuteOptions.to} /></h4></span>
                </div>
                <div className="trip-date-passengers info-box hide-me">
                    <span className="trip-date"><h4>{tripDetails.date}</h4></span>
                    <table clasName="trip-passengers">
                        {tripDetails.booker && 
                        <tr>
                            <td>Passenger 1 (Booker):</td><td><h4>{tripDetails.booker}</h4></td>
                        </tr>
                        }
                        {tripDetails.passengers &&
                            Object.keys(tripDetails.passengers).map(key =>
                                <tr>
                                    <td>Passenger {parseInt(key) + 1}:</td><td><h5>{tripDetails.passengers[key]}</h5></td>
                                </tr>
                            )
                        }
                      
                    </table>
                </div>
                <div className="time-info info-box">
                    <span className="departure-time info-grid hide-me">
                        <h4>Departure</h4>
                        <span className="from"><i>{tripDetails.depFrom}</i></span>
                    </span>
                    <span className="arrival-time info-grid hide-me">
                        <h4>Arrival</h4>
                        <span className="from"><i>{tripDetails.arrFrom}</i></span>
                    </span>
                </div>
                <div className="price-info info-box">
                    {tripDetails.priceFrom &&
                    
                        <span className="price info-grid">
                            <h4>Final price </h4>
                        <span className="price total"><i>{tripDetails.priceFrom}  SEK</i></span>
                        <h5 className="hide-me">Flexible reduction</h5>
                        <span className="price price-reduction hide-me"><i>{tripDetails.priceFlexRed} SEK</i><button className="button button-what">?</button></span>
                        <h5 className="hide-me">Place fill reduction</h5>
                        <span className="price price-reduction hide-me"><i>{tripDetails.priceFillRed} SEK</i><button className="button button-what">?</button></span>
                        </span>
                    }
                    
                </div>
            </div>
        </div>
    )
}

export default TripInfoFinal